import React, { useState } from "react";
import { AppProvider } from "./AppContext";
import LoginPage          from "./LoginPage";
import LandingPage        from "./LandingPage";
import ParentDashboard    from "./ParentDashboard";
import KioskCheckIn       from "./KioskCheckIn";
import RegistrationForm   from "./RegistrationForm";
import API_BASE           from "./apiConfig";

// Public standalone route — no login required
const PUBLIC_PATHS = ["/register", "/register/"];
const isPublicPath = PUBLIC_PATHS.includes(window.location.pathname);

export default function App() {
  const [currentUser, setCurrentUser] = useState(() => {
    try { const s = localStorage.getItem("sixers_user"); return s ? JSON.parse(s) : null; }
    catch { return null; }
  });

  // Serve the public registration form without any login check
  if (isPublicPath) {
    return (
      <AppProvider>
        <RegistrationForm />
      </AppProvider>
    );
  }

  const handleLogin = (user) => {
    localStorage.setItem("sixers_user", JSON.stringify(user));
    setCurrentUser(user);
  };
  const handleLogout = () => {
    const token = currentUser?.session_token;
    localStorage.removeItem("sixers_user");
    setCurrentUser(null);
    if (token) {
      fetch(`${API_BASE}/auth/logout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_token: token }),
      }).catch(() => {});
    }
  };

  const role     = currentUser?.user_role;
  const isParent = role === "Parent";
  const isKiosk  = role === "Kiosk";

  return (
    <AppProvider>
      {!currentUser
        ? <LoginPage onLogin={handleLogin} />
        : isParent
          ? <ParentDashboard currentUser={currentUser} onLogout={handleLogout} />
          : isKiosk
            ? <KioskCheckIn currentUser={currentUser} onLogout={handleLogout} />
            : <LandingPage
                currentUser={currentUser}
                currentUserId={currentUser.user_id}
                onLogout={handleLogout}
              />
      }
    </AppProvider>
  );
}
